import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { HttpClient } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { EndpointService } from '@app/core';
import {
  AsociacionReporteTramite,
} from '@app/shared';

@Injectable()
export class ReportsDataSourceDataService {
  constructor(private http: HttpClient, private toastr: ToastrService, private api: EndpointService) {}

  /**
   * Agrega una asociacion de un tramite a un reporte
   *
   * @param {AsociacionReporteTramite} data
   * @returns {Observable<boolean>}
   * @memberof ReportsDataSourceDataService
   */
  addAsociationReportTramite(data: AsociacionReporteTramite): Observable<boolean> {
    return new Observable(obs => {
      this.http.post<boolean>(this.api.get('reportTramites'), data).subscribe(
        report => {
          this.toastr.success('Asociación creada correctamente', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

  /**
   * Elimina la asociacion de un tramite a un reporte
   *
   * @param {number} idAsociation
   * @returns {Observable<boolean>}
   * @memberof ReportsDataSourceDataService
   */
  deleteAsociationReportTramite(idAsociation: number): Observable<boolean> {
    return new Observable(obs => {
      this.http.delete<boolean>(this.api.get('reportTramites', [idAsociation])).subscribe(
        report => {
          this.toastr.success('Asociación eliminada correctamente', 'Operación exitosa');
          obs.next(true);
        },
        err => {
          obs.error(err);
        }
      );
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/administration/management-reports/reports/reports-data-source/shared/reports-data-source.data.service.ts